module.exports = __webpack_public_path__ + "img/citas-completadas-no-confirmadas.db122c47.svg";